import React from 'react';
import './style.less';
import { Icon } from 'shared/components/Icon';
import { useAppDispatch, useAppSelector } from 'shared/store';
import { endCall, setOutgoingMediaEnabled } from 'shared/store/dashboard-slice';
import clsx from 'clsx';
import { ChatPopupActiveCallSettings } from './Settings';

export const ChatPopupActiveCallToolbar = () => {
  const dispatch = useAppDispatch();
  const { isOutgoingAudioEnabled, isOutgoingVideoEnabled } = useAppSelector(
    s => s.dashboard,
  );

  const toggleCamera = () =>
    dispatch(
      setOutgoingMediaEnabled({ isOutgoingVideoEnabled: !isOutgoingVideoEnabled }),
    );

  const toggleMicrophone = () =>
    dispatch(
      setOutgoingMediaEnabled({ isOutgoingAudioEnabled: !isOutgoingAudioEnabled }),
    );

  return (
    <div className="ChatPopupActiveCallToolbar">
      <button
        className={clsx(
          'ChatPopupActiveCallToolbar__item',
          isOutgoingAudioEnabled && `ChatPopupActiveCallToolbar__item--active`,
        )}
        onClick={toggleMicrophone}
      >
        <Icon
          icon={isOutgoingAudioEnabled ? 'micSalesfloorOn' : 'micSalesfloorOff'}
          width={16}
          height={16}
        />
      </button>
      <button className="ChatPopupActiveCallToolbar__item" onClick={toggleCamera}>
        <Icon
          icon={isOutgoingVideoEnabled ? 'cameraSalesfloorOn' : 'cameraSalesfloorOff'}
          width={16}
          height={16}
        />
      </button>
      <ChatPopupActiveCallSettings />
      <button
        className="ChatPopupActiveCallToolbar__item ChatPopupActiveCallToolbar__item--end"
        onClick={() => {
          dispatch(endCall());
        }}
      >
        <Icon icon="phoneHang" width={16} height={16} />
      </button>
    </div>
  );
};
